<ion-content>
  <ion-list>
    <ion-item class="ion-activatable" *ngFor="let outletType of outletTypes | sortByName: 'label'" (click)="selectType(outletType.id, outletType.label)">
      <img class="type-img" [src]="'../../assets/outlet-type-icons/' + outletType.iconName + '.png'">
      <ion-label>{{outletType.label}}</ion-label>
      <app-icon *ngIf="isSelected(outletType.id)" name="checkmark" color="primary"></app-icon>
    </ion-item>
  </ion-list>
</ion-content>
